import { useMemo } from "react";
import {
  selectMostRecentRecipes,
  selectInProgressCookingProgresses,
  useT,
  useAppSelector,
} from "@reciperoll/core";
import { PlusCircle } from "react-feather";
import { RecipeRail } from "./RecipeRail";

const RECENTLY_ADDED_LIMIT = 12;

// The most recently added recipes. "See all" goes to the library, which already
// defaults to recently-added order.
export default function RecentlyAdded() {
  const t = useT();
  const selectRecent = useMemo(() => selectMostRecentRecipes(RECENTLY_ADDED_LIMIT), []);
  const recipes = useAppSelector(selectRecent);
  const cookingIds = new Set(
    useAppSelector(selectInProgressCookingProgresses).map((cp) => cp.recipeId),
  );

  return (
    <RecipeRail
      title={t("home.recentlyAdded")}
      icon={<PlusCircle className="w-5 h-5" />}
      eyebrow={t("home.recentlyAddedEyebrow")}
      link="/recipes"
      recipes={recipes}
      cookingIds={cookingIds}
    />
  );
}
